import React, { useState } from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  Button,
  Collapse,
  IconButton,
  Tooltip
} from '@mui/material';
import {
  Person as PersonIcon,
  Receipt as ReceiptIcon,
  Store as StoreIcon,
  ExpandMore as ExpandMoreIcon,
  ExpandLess as ExpandLessIcon
} from '@mui/icons-material'; // Añadir ExpandMoreIcon y ExpandLessIcon

const ResumenPorCliente = ({ clientes, onFacturarCliente }) => {
  const [expanded, setExpanded] = useState(true); // Estado para controlar expansión
  const [expandedCliente, setExpandedCliente] = useState(null);

  const handleExpandCliente = (id) => {
    setExpandedCliente(expandedCliente === id ? null : id);
  };

  const calcularPorcentaje = (parcial, total) => {
    return total > 0 ? Math.round((parcial / total) * 100) : 0;
  };
  

  return (
    <Card sx={{ height: '100%', mt: 2 }}>
      <CardContent>
        {/* Header plegable */}
        <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
          <Box display="flex" alignItems="center">
            <PersonIcon color="primary" sx={{ mr: 1 }} />
            <Typography variant="h6" fontWeight="bold">
              Resumen por Cliente
            </Typography>
            <Chip 
              label={`${clientes.length} clientes`}
              size="small"
              sx={{ ml: 2 }}
            />
          </Box>
          <IconButton 
            size="small"
            onClick={() => setExpanded(!expanded)}
          >
            {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        </Box>

        <Collapse in={expanded}>
          <TableContainer component={Paper} variant="outlined" sx={{ maxHeight: 400 }}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: 'bold' }}>Cliente</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }} align="center">Pedidos</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }} align="center">Acciones</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {clientes.map((cliente) => (
                  <React.Fragment key={cliente.id_cliente}>
                    <TableRow hover>
                      <TableCell>
                        <Box>
                          <Typography variant="body2" fontWeight="medium">
                            {cliente.cliente}
                          </Typography>
                          <Typography variant="caption" color="text.secondary" display="flex" alignItems="center">
                            <StoreIcon sx={{ fontSize: 12, mr: 0.5 }} />
                            {cliente.sucursal}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell align="center">
                        <Typography variant="body1" fontWeight="bold">
                          {cliente.pedidos}
                        </Typography>
                      </TableCell>
                      <TableCell align="center">
                        <Box display="flex" justifyContent="center" gap={0.5}>
                          <Tooltip title="Ver detalles">
                            <IconButton 
                              size="small"
                              onClick={() => handleExpandCliente(cliente.id_cliente)}
                            >
                              {expandedCliente === cliente.id_cliente ? 
                                <ExpandLessIcon fontSize="small" /> : 
                                <ExpandMoreIcon fontSize="small" />
                              }
                            </IconButton>
                          </Tooltip>
                          {/* {cliente.facturados < cliente.pedidos && ( */}
                            <Tooltip title="Facturar pendientes">
                              <IconButton 
                                size="small"
                                color="primary"
                                onClick={() => onFacturarCliente(cliente.id_cliente)}
                              >
                                <ReceiptIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          {/*  )} */}
                        </Box>
                      </TableCell>
                    </TableRow>
                    
                    {/* Detalles expandidos */}
                    {expandedCliente === cliente.id_cliente && (
                      <TableRow>
                        <TableCell colSpan={5} sx={{ py: 1, backgroundColor: '#f9f9f9' }}>
                          <Box sx={{ pl: 2 }}>
                            <Typography variant="caption" fontWeight="bold" color="text.secondary">
                              Productos entregados:
                            </Typography>
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 0.5 }}>
                              {cliente.entregas.map((entrega, idx) => (
                                <Box
                                  key={entrega.idPedido ?? idx}
                                  sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 0.75,
                                    px: 1,
                                    py: 0.5,
                                    backgroundColor: 'white',
                                    border: '1px solid #e0e0e0',
                                    borderRadius: 1,
                                  }}
                                >
                                  <Chip
                                    icon={<ReceiptIcon sx={{ fontSize: '0.8rem !important' }} />}
                                    label={entrega.remito || 'Sin remito'}
                                    size="small"
                                    variant="outlined"
                                    sx={{
                                      height: 20,
                                      fontSize: '0.65rem',
                                      fontWeight: 'bold',
                                      flexShrink: 0,
                                    }}
                                  />
                                  <Typography variant="caption" noWrap>
                                    {entrega.producto}
                                  </Typography>
                                </Box>
                              ))}
                            </Box>
                            
                            {/* <Box sx={{ mt: 1, display: 'flex', gap: 2 }}>
                              <Typography variant="caption" color="text.secondary">
                                ID Cliente: <strong>{cliente.id_cliente}</strong>
                              </Typography>
                              <Typography variant="caption" color="text.secondary">
                                Por facturar: <strong>{cliente.pedidos - cliente.facturados}</strong>
                              </Typography>
                            </Box> */}
                            
                            
                          </Box>
                        </TableCell>
                      </TableRow>
                    )}
                  </React.Fragment>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Collapse>
      </CardContent>
    </Card>
  );
};

export default ResumenPorCliente;